import React from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import './styles.css';

const Analise = () => {
  return (
    <>
      <Card className="text-center">
        <Card.Header><div className="opcoes">Análise do Ambiente</div></Card.Header>
        <Card.Body>
          {/* <Card.Title>Roteadores Robustos</Card.Title> */}
          <Card.Text>
            <div className="opcoes">
              <strong>Complexidade do Ambiente: </strong>
              A análise precisa de um ambiente Wi-Fi pode ser desafiadora devido às muitas variáveis envolvidas, 
              como interferências de sinal e a composição física do espaço. 
            </div>
            <div className="opcoes">
              <strong>Utilização de Ferramentas Apropriadas: </strong>
              Sem o uso adequado de ferramentas de análise e diagnóstico, a identificação de zonas mortas e fontes de interferência 
              pode ser insuficiente, impactando negativamente o desempenho da rede.
            </div>            
          </Card.Text>
          {/* <Button variant="primary">Go somewhere</Button> */}
        </Card.Body>
        {/* <Card.Footer className="text-muted">Alternativas acessíveis para cenários que não disponha do investimento.  </Card.Footer> */}
      </Card>
    </>
  )
}
export default Analise;